import {VersionVariants} from '@jobseeker/lotus/enums';
import {PropTypes} from './type';
import MuiDialog from '@mui/material/Dialog';
import V2 from './V2';
import V3 from './V3';
import V4 from './V4';
import V1Hirist from './V1Hirist';

import V5 from './V5';
import V6 from './V6';
const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = MuiDialog;
componentMap[VersionVariants.VERSION_TWO] = V2;
componentMap[VersionVariants.VERSION_THREE] = V3;
componentMap[VersionVariants.VERSION_HIRIST_V1] = V1Hirist;
componentMap[VersionVariants.VERSION_SEVEN] = V5;
componentMap[VersionVariants.VERSION_EIGHT] = V6;
componentMap[VersionVariants.VERSION_FOUR] = V4;

const Dialog = (props: PropTypes) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default Dialog;
